module.exports = __webpack_public_path__ + "static/media/location_icon_selected.3fa4608d.svg";